import logo from '../assets/logo.png'
import eyeOff from '../assets/eyeOff.png'
import eyeOnn from '../assets/eyeOnn.png'
import Dashboard from '../assets/dashboard.png'
import Users from '../assets/users.png'
import Category from '../assets/category.png'
import UsersDashboard from '../assets/UsersDash.png'
import Men from '../assets/men.png'
import Women from '../assets/women.png'
import NonBinary from '../assets/non_binary.png'
import DeleteIcon from '../assets/delete.png'
import ViewIcon from '../assets/view.png'
import DeleteCircleIcon from '../assets/deleteWithCircle.png'
import Edit from '../assets/edit.png'
import Filter from '../assets/filterIcon.png'
import Height from '../assets/height.png'
import Smoke from '../assets/noSmkoe.png'
import Kid from '../assets/kid.png'
import Alcohol from '../assets/alcohol.png'
import Monogamy from '../assets/monogomy.png'
import Tablets from '../assets/tablets.png'
import Terms from '../assets/terms.png'
import Privacy from '../assets/privacy.png'
import FAQ from '../assets/faq.png'
import Upload from '../assets/upload.png'
export const STATIC_IMAGES = {
    LOGO: logo,
    EYE_OFF: eyeOff,
    EYE_ONN: eyeOnn,
    DELETE: DeleteIcon,
    FILTER: Filter,
    UPLOAD: Upload,
    SIDE_BAR: {
        DASHBOARD:Dashboard,
        USERS:Users,
        CATEGORY:Category,
        TERMS:Terms,
        PRIVACY:Privacy,
        FAQ:FAQ,
    },
    DASHBOARD:{
        USERS:UsersDashboard,
        MEN:Men,
        WOMEN:Women,
        NON_BINARY:NonBinary,
    },
    TABLE:{
        VIEW_ICON:ViewIcon,
        DELETE_CIRCLE_ICON:DeleteCircleIcon,
        EDIT:Edit,
    },
    USER:{
        HEIGHT:Height,
        KIDS:Kid,
        ALCOHOL:Alcohol,
        SMOKE:Smoke,
        MONOGAMY:Monogamy,
        TABLETS:Tablets,
    }
}